import { Map } from 'immutable';
import {
    SAVE_SERVICE_TYPE,
    GET_PAGE_PATH
} from '../actions/createRelocation';



const initialState = Map({
    ApiData: {},
    serrr: {},
    pagePath: ""
});

const actionsMap = {
    [SAVE_SERVICE_TYPE]: (state, action) => {
        return state.set('ApiData', action.data);
    },
    [GET_PAGE_PATH]: (state, action) => {
        return state.set('pagePath', action.data);
    }
};

export default function facilities(state = initialState, action = {}) {
    const fn = actionsMap[action.type];
    return fn ? fn(state, action) : state;
}
